import { gql } from '@apollo/client';

export const GET_FILES = gql`
  query EXCHANGE_SERVICE_getFiles(
    $from: String!
    $to: String!
    $sponsorId: String! = ""
    $status: String! = ""
    $path: String! = ""
    $page: Int! = 1
  ) {
    getFiles(from: $from, to: $to, sponsorId: $sponsorId, status: $status, path: $path, page: $page) {
      result {
        id
        sponsorId
        date
        dateTime
        sftpPath
        direction
        status
        failCause
      }
      totalElements
      currentPage
      totalPages
    }
  }
`;

export const GENERATE_ZIP_FILE = gql`
  mutation EXCHANGE_SERVICE_generateZipFile(
    $from: String!
    $to: String!
    $sponsorId: String! = ""
    $status: String! = ""
    $path: String! = ""
  ) {
    generateZipFile(from: $from, to: $to, sponsorId: $sponsorId, status: $status, path: $path)
  }
`;

export const RESEND_FILE = gql`
  mutation EXCHANGE_SERVICE_resendFile($fileId: String!) {
    resendFile(fileId: $fileId) {
      id
      sponsorId
      date
      dateTime
      sftpPath
      direction
      status
      failCause
    }
  }
`;

export const SEND_FILE = gql`
  mutation EXCHANGE_SERVICE_sendFile($fileId: String!, $sponsorId: String!, $service: Service) {
    sendFile(fileId: $fileId, sponsorId: $sponsorId, service: $service) {
      id
      sponsorId
      date
      dateTime
      sftpPath
      direction
      status
      failCause
    }
  }
`;
